"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var game_api_1 = __importDefault(require("@l2p/game-api"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ProvidersList = function (_a) {
    var providers = _a.providers, onItemClick = _a.onItemClick, selectedProviderId = _a.selectedProviderId;
    return (game_api_1.default.createElement("div", { className: styles_module_scss_1.default.container }, providers.map(function (provider) { return (game_api_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.providerItem, " ").concat(selectedProviderId === provider.id ? styles_module_scss_1.default.selectedProviderItem : ''), onClick: function () { return onItemClick && onItemClick(provider.id); }, key: provider.id },
        game_api_1.default.createElement("div", { className: styles_module_scss_1.default.providerItemRect }),
        game_api_1.default.createElement("div", { className: styles_module_scss_1.default.providerTitle }, provider.title))); })));
};
exports.default = ProvidersList;
